import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SnackService } from './snack.service';
import { frontendserverurl, serverurl } from '../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class FlyingAgentsService {

  constructor(
    private http: HttpClient,
    private snack: SnackService
  ) { }

  async getAllAgentPrompts() {
    return await new Promise((resolve) => {
      this.http.get(frontendserverurl + '/aiservice/flying-agents/').subscribe({
        next: async (data: any) => {
          console.log(data);

          resolve(data)
        },
        error: (err) => {
          this.snack.error(err);
          resolve(false);
        }
      })
    })
  }
}
